export default {"src":"/_next/static/media/men-icon.95f6daac.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};